import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import FlatPickr from "react-flatpickr";
import "flatpickr/dist/themes/material_blue.css";
import Select from "react-select";
import { toast } from "react-toastify";
import {
  setSortFieldConfigMessagerie,
  setOrderConfigMessagerie,
  setCurrentPageConfigMessagerie,
  setValueConfigMessagerie,
  setStatutConfigMessagerie,
} from "../../store/actions";
import InputMask from "react-input-mask";
//import components
import Breadcrumbs from "../../components/Common/Breadcrumb";
import DeleteModal from "../../components/Common/DeleteModal";
import ReactPaginate from "react-paginate";
//redux

import { useSelector, useDispatch } from "react-redux";
import {
  Col,
  Row,
  Card,
  CardBody,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  ButtonDropdown,
} from "reactstrap";
import Spinners from "components/Common/Spinner";
import { ToastContainer } from "react-toastify";
import useDebounce from "./useDebounce";
import { useNavigate } from "react-router-dom";
import Config from "config";
import DeleteButton from "components/Common/DeleteButtonList";
import LastModificationAlert from "components/Common/Alert";
function ConfigMessagerie() {
  const backUrl = Config.backOffice.url;
  const api = Config.backOffice.apiName;
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const badgeStyle = { fontSize: "100%" };
  const toggleDropdown = () => setDropdownOpen(!dropdownOpen);
  const [loading, setLoading] = useState(true);
  //   const investData = useSelector((state) => state.Investisseurs.investData);
  const [investData, setInvestData] = useState([]);
  const token = localStorage.getItem("auth_token_" + api);
  const [redirectToLoginPage, setRedirect] = useState(false);

  // Pagination

  const currentPage = useSelector(
    (state) => state.FiltreConfigMessagerie.currentPage
  );
  const itemsPerPage = 20; // Limite d'affichage par page
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  //   const currentItems = investData.slice(indexOfFirstItem, indexOfLastItem);
  //Recherche
  const value = useSelector((state) => state.FiltreConfigMessagerie.value);

  const statut = useSelector((state) => state.FiltreConfigMessagerie.statut);

  const debounceSearch = useDebounce(value, 500);

  // Triage
  const handleSorting = async (sortField, sortOrder) => {
    try {
      const response = await fetch(
        `https://www.fluxod.com/${api}/smtp_parametres?page=1&sort_by=${sortField}_${sortOrder}&key=${debounceSearch}&paiement_statut_value=${statut}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      const newData = await response.json();
      const upData = newData;
      setInvestData(upData);
    } catch (error) {
      console.error("Error fetching data: ", error);
    }
  };
  //Thead
  const sortField = useSelector(
    (state) => state.FiltreConfigMessagerie.sortField
  );
  const order = useSelector((state) => state.FiltreConfigMessagerie.order);
  const [isSorting, setIsSorting] = useState(false);
  const handleSortingChange = (accessor) => {
    dispatch(setCurrentPageConfigMessagerie(1));
    setIsSorting(true);
    const sortOrder =
      accessor === sortField && order === "asc" ? "desc" : "asc";

    dispatch(setSortFieldConfigMessagerie(accessor));
    dispatch(setOrderConfigMessagerie(sortOrder));

    handleSorting(accessor, sortOrder); // Appel à la fonction de tri
    setIsSorting(false);
  };

  //meta title
  document.title = "Compte de messagerie | DOM COM";

  // validation

  //   useEffect(() => {

  //     if (token) {
  //       dispatch(fetchInvestRequest(token));
  //     }
  //   }, [dispatch, token]);
  useEffect(() => {
    if (redirectToLoginPage == true) {
      localStorage.removeItem("auth_token_" + api);
      localStorage.removeItem("authUser_" + api);
      localStorage.removeItem("sideBar_" + api);
      navigate(`${backUrl}/login`);
      window.location.reload(false);
    }
    if (localStorage.getItem("key") === "true") {
      toast.success("Mise à jour réussie");
      localStorage.setItem("key", "false");
    }
  }, [redirectToLoginPage, navigate]);
  const fetchPage = async (currentPage) => {
    try {
      const res = await fetch(
        `https://www.fluxod.com/${api}/smtp_parametres?page=${currentPage}&sort_by=${sortField}_${order}&key=${debounceSearch}&paiement_statut_value=${statut}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      const data = await res.json();
      return data;
    } catch (error) {
      console.error("Error fetching page: ", error);
    }
  };

  const handlePageChange = async (data) => {
    let currentPage = data.selected + 1;
    const getData = await fetchPage(currentPage);
    dispatch(setCurrentPageConfigMessagerie(currentPage));
    setInvestData(getData);
  };
  // Filtre

  const [filterParams, setFilterParams] = useState("");

  // Mettre à jour les paramètres de filtre et déclencher la fonction de filtrage avec débordement

  // Fonction pour mettre à jour l'état du filtre et appeler la mise à jour des paramètres accumulés
  const handleFilterChange = (accessor, value) => {
    const updatedFilters = investData.filters.map((filter) => {
      if (filter.accessor === accessor) {
        return {
          ...filter,
          value: value,
        };
      }
      return filter;
    });

    setInvestData((prevData) => ({
      ...prevData,
      filters: updatedFilters,
    }));

    // Mettre à jour les paramètres de filtre
  };

  // La fonction de filtrage reste inchangée, elle utilise les paramètres de filtre accumulés
  const handleFiltering = async () => {
    try {
      const response = await fetch(
        `https://www.fluxod.com/${api}/smtp_parametres?page=${currentPage}&sort_by=${sortField}_${order}&key=${debounceSearch}&paiement_statut_value=${statut}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (response.status === 403) {
        navigate(`${backUrl}/forbidden`);
      }
      if (response.status === 500) {
        navigate(`${backUrl}/error`);
      }
      if (response.status === 203) {
        navigate(`${backUrl}/error404`);
      }
      // if (!response.ok) {
      //   redirectToLoginPage = true;

      //   throw new Error("La réponse du réseau n'est pas valide");
      // }

      const newData = await response.json();
      setInvestData(newData);
      console.log(newData);
    } catch (error) {
      console.error("Erreur lors de la récupération des données : ", error);
    }
  };

  const renderFilters = () => {
    const handleFilterValidation = () => {
      handleFiltering(investData.filters);
    };

    return (
      <>
        {!loading ? (
          <>
            {investData?.filters?.map((filter, index) => {
              switch (filter.accessor) {
                case "key":
                  return (
                    <Col md={2} className="mb-1" key={index}>
                      <input
                        defaultValue={value}
                        className="form-control mb-3 mb-xxl-0"
                        type="text"
                        placeholder={filter.label}
                        onChange={(e) => {
                          dispatch(setValueConfigMessagerie(e.target.value));
                          dispatch(setCurrentPageConfigMessagerie(1));
                          handleFilterChange(filter.accessor, value);
                        }}
                      />
                    </Col>
                  );

                case "paiement_statut_value":
                  return (
                    <Col md={2} className="mb-1" key={index}>
                      <select
                        className="form-control mb-3 mb-xxl-0"
                        onChange={(e) => {
                          dispatch(setStatutConfigMessagerie(e.target.value)),
                            dispatch(setCurrentPageConfigMessagerie(1));
                          handleFilterChange(filter.accessor, statut);
                        }}
                      >
                        <option value="">{filter.label}</option>
                        {filter.list.map((item, itemIndex) => (
                          <option key={itemIndex} value={item.id}>
                            {item.label}
                          </option>
                        ))}
                      </select>
                    </Col>
                  );

                default:
                  return null;
              }
            })}
          </>
        ) : (
          ""
        )}
      </>
    );
  };

  useEffect(() => {
    const handleFiltering = async () => {
      try {
        const response = await fetch(
          `https://www.fluxod.com/${api}/smtp_parametres?page=${currentPage}&sort_by=${sortField}_${order}&key=${debounceSearch}&paiement_statut_value=${statut}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        if (response.status === 403) {
          navigate(`${backUrl}/forbidden`);
        }
        if (response.status === 500) {
          navigate(`${backUrl}/error`);
        }
        if (response.status === 203) {
          navigate(`${backUrl}/error404`);
        }

        const newData = await response.json();
        setInvestData(newData);
      } catch (error) {
        console.error("Erreur lors de la récupération des données : ", error);
      }
    };

    handleFiltering();
  }, []);

  useEffect(() => {
    const handleFiltering = async () => {
      try {
        const response = await fetch(
          `https://www.fluxod.com/${api}/smtp_parametres?page=${currentPage}&sort_by=${sortField}_${order}&key=${debounceSearch}&paiement_statut_value=${statut}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        if (response.status === 403) {
          navigate(`${backUrl}/forbidden`);
        }
        if (response.status === 500) {
          navigate(`${backUrl}/error`);
        }
        if (response.status === 203) {
          navigate(`${backUrl}/error404`);
        }
        if (response.status === 401) {
          localStorage.removeItem("auth_token_" + api);
          localStorage.removeItem("authUser_" + api);
          localStorage.removeItem("sideBar_" + api);
          navigate(`${backUrl}/login`);
          window.location.reload(false);
        }

        dispatch(setCurrentPageConfigMessagerie(1));
        const newData = await response.json();
        setInvestData(newData);
      } catch (error) {
        console.error("Erreur lors de la récupération des données : ", error);
      }
    };

    if (currentPage === 1) {
      handleFiltering();
    }
  }, [debounceSearch, statut]);
  const lastId = localStorage.getItem("lastId");
  const previousPath = localStorage.getItem("previousPath_" + api);
  return (
    <React.Fragment>
      {/* <DeleteModal
       show={deleteModal}
       onDeleteClick={}
       onCloseClick={() => setDeleteModal(false)}
      /> */}
      <div className="page-content">
        {previousPath == `${backUrl}/smtp_parametres/${lastId}/edit` ? (
          <LastModificationAlert path={"smtp_parametres"} />
        ) : null}
        <div className="container-fluid">
          <Row>
            <Col lg="12">
              <Card>
                <CardBody className="border-bottom">
                  <div className="d-flex align-items-center">
                    <h5 className="mb-0 card-title text-primary flex-grow-1">
                      Compte de messagerie (
                      {loading ? "--" : investData?.total_records})
                    </h5>
                  </div>

                  <div className="d-flex justify-content-end">
                    <div className="d-flex align-items-end">
                      {investData?.can_add ? (
                        <Link
                          to={`${backUrl}/smtp_parametres/new`}
                          className="btn btn-sm btn-primary"
                        >
                          <i className="bx bx-plus"></i>Ajouter
                        </Link>
                      ) : null}
                      &nbsp; &nbsp;
                      {/* <Link to="#!" className="btn btn-sm btn-light me-1">
                        <i className="mdi mdi-export-variant"></i>Exporter
                      </Link> */}
                    </div>
                  </div>
                </CardBody>
                <CardBody>
                  {!loading ? (
                    <>
                      <Row className="mb-3">{renderFilters()}</Row>
                    </>
                  ) : (
                    ""
                  )}

                  <div className="table-responsive">
                    {!loading ? (
                      <>
                        <table className="table">
                          <thead>
                            <tr>
                              {investData?.can_edit === false &&
                              investData?.can_show === false &&
                              investData?.can_destroy === false ? (
                                <th></th>
                              ) : (
                                <th
                                  style={{ cursor: "default" }}
                                  key="Action"
                                  className="text"
                                >
                                  Action
                                </th>
                              )}

                              {investData?.headers?.map(
                                ({ label, accessor, sortable }) => {
                                  const cl = sortable ? (
                                    sortField === accessor ? (
                                      order === "asc" ? (
                                        <i className="bx bx-up-arrow-alt"></i>
                                      ) : (
                                        <i className="bx bx-down-arrow-alt"></i>
                                      )
                                    ) : (
                                      ""
                                    )
                                  ) : (
                                    ""
                                  );
                                  return (
                                    <th
                                      key={accessor}
                                      onClick={
                                        sortable
                                          ? () => handleSortingChange(accessor)
                                          : null
                                      }
                                      className="text-nowrap"
                                      style={{
                                        cursor: sortable
                                          ? "pointer"
                                          : "default",
                                      }}
                                    >
                                      {label}
                                      {cl}
                                    </th>
                                  );
                                }
                              )}
                            </tr>
                          </thead>
                          <tbody>
                            {investData?.data?.map((rowData, rowIndex) => (
                              <tr key={rowIndex}>
                                <td key={rowIndex}>
                                  <ul className="list-unstyled hstack gap-1 mb-0">
                                    {investData?.can_show ? (
                                      <li
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="View"
                                      >
                                        <Link
                                          className="btn btn-sm btn-soft-primary"
                                          id="viewtooltip-2"
                                          to={`${backUrl}/smtp_parametres/${rowData.id}`}
                                        >
                                          <i className="mdi mdi-eye-outline"></i>
                                        </Link>
                                      </li>
                                    ) : null}
                                    {investData?.can_edit ? (
                                      <li title="Editer">
                                        <Link
                                          className="btn btn-sm btn-soft-info"
                                          id="edittooltip-2"
                                          to={`${backUrl}/smtp_parametres/${rowData.id}/edit`}
                                          state={{ active: "details" }}
                                        >
                                          <i className="mdi mdi-pencil-outline"></i>
                                        </Link>
                                      </li>
                                    ) : null}
                                    {investData?.can_destroy ? (
                                      <li title="Supprimer">
                                        <DeleteButton
                                          url={`https://www.fluxod.com/${api}/smtp_parametres/${rowData.id}`}
                                        />
                                      </li>
                                    ) : null}
                                  </ul>
                                </td>
                                {investData?.headers?.map(
                                  ({ label, accessor }) => (
                                    <>
                                      {console.log(accessor)}

                                      {rowData[accessor] === "Faible" ? (
                                        <td key={`${rowIndex}-${accessor}`}>
                                          <span
                                            className="bg-warning badge bg-secondary"
                                            style={badgeStyle}
                                          >
                                            {rowData[accessor] || "——"}
                                          </span>
                                        </td>
                                      ) : label ===
                                          "ConfigMessagerie archive" &&
                                        rowData[accessor] != null ? (
                                        <td
                                          style={{
                                            padding: "12px",
                                            fontFamily: "Sans-Serif",
                                          }}
                                          key={`${rowIndex}-${accessor}`}
                                        >
                                          <a href={rowData[accessor]} download>
                                            <i
                                              style={{
                                                fontSize: "25px",
                                                paddingLeft: "8px",
                                                textalign: "center",
                                                verticalalign: "middle",
                                              }}
                                              className="bx bx-download"
                                            ></i>
                                          </a>
                                        </td>
                                      ) : label === "Partenaire" ? (
                                        <td
                                          style={{
                                            padding: "12px",
                                            fontFamily: "Sans-Serif",
                                          }}
                                          key={`${rowIndex}-${accessor}`}
                                        >
                                          {rowData[accessor] || "——"}
                                        </td>
                                      ) : rowData[accessor] === "Moyen" ? (
                                        <td key={`${rowIndex}-${accessor}`}>
                                          <span
                                            className="bg-info badge bg-secondary"
                                            style={badgeStyle}
                                          >
                                            {rowData[accessor] || "——"}
                                          </span>
                                        </td>
                                      ) : rowData[accessor] === "A faire" ||
                                        rowData[accessor] === "En attente" ? (
                                        <td key={`${rowIndex}-${accessor}`}>
                                          <span
                                            className="badge-soft-info badge bg-secondary"
                                            style={badgeStyle}
                                          >
                                            {rowData[accessor] || "——"}
                                          </span>
                                        </td>
                                      ) : rowData[accessor] === "Non payée" ? (
                                        <td key={`${rowIndex}-${accessor}`}>
                                          <span
                                            className="badge-soft-danger badge bg-secondary"
                                            style={badgeStyle}
                                          >
                                            {rowData[accessor] || "——"}
                                          </span>
                                        </td>
                                      ) : rowData[accessor] === "Oui" ||
                                        rowData[accessor] === "Validé" ||
                                        rowData[accessor] === "Payée" ? (
                                        <td key={`${rowIndex}-${accessor}`}>
                                          <span
                                            className="badge-soft-success badge bg-secondary"
                                            style={badgeStyle}
                                          >
                                            {rowData[accessor] || "——"}
                                          </span>
                                        </td>
                                      ) : rowData[accessor] === "Élevé" ? (
                                        <td key={`${rowIndex}-${accessor}`}>
                                          <span
                                            className="bg-danger badge bg-secondary"
                                            style={badgeStyle}
                                          >
                                            {rowData[accessor] || "——"}
                                          </span>
                                        </td>
                                      ) : typeof rowData[accessor] ===
                                          "number" && accessor != "port" ? (
                                        <td
                                          className={"text-end"}
                                          style={{
                                            // width: "33.33%",
                                            padding: "12px",
                                            fontFamily: "Sans-Serif",
                                          }}
                                          key={`${rowIndex}-${accessor}`}
                                        >
                                          {rowData[accessor]
                                            .toLocaleString("fr-FR", {
                                              style: "currency",
                                              currency: "EUR",
                                            })
                                            .replace("€", "")}
                                        </td>
                                      ) : (
                                        <td
                                          style={{
                                            padding: "12px",
                                            fontFamily: "Sans-Serif",
                                          }}
                                          key={`${rowIndex}-${accessor}`}
                                        >
                                          {rowData[accessor] || "——"}
                                        </td>
                                      )}
                                    </>
                                  )
                                )}
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </>
                    ) : (
                      <Spinners setLoading={setLoading} setWait={400} />
                    )}
                  </div>
                </CardBody>
                <div className="d-flex justify-content-center mt-3">
                  {!loading ? (
                    <ReactPaginate
                      previousLabel={"<<"}
                      breakLabel={"..."}
                      nextLabel={">>"}
                      pageCount={investData.pages}
                      marginPagesDisplayed={2}
                      pageRangeDisplayed={3}
                      onPageChange={handlePageChange}
                      containerClassName={"pagination justify-content-center"}
                      pageClassName={"page-item"}
                      pageLinkClassName={"page-link"}
                      previousClassName={"page-item"}
                      previousLinkClassName={"page-link"}
                      nextClassName={"page-item"}
                      nextLinkClassName={"page-link"}
                      breakClassName={"page-item"}
                      breakLinkClassName={"page-link"}
                      activeClassName={"active"}
                      forcePage={currentPage - 1}
                    />
                  ) : (
                    ""
                  )}
                </div>
              </Card>
            </Col>
          </Row>
        </div>
      </div>

      <ToastContainer />
    </React.Fragment>
  );
}

export default ConfigMessagerie;
